import { z } from 'zod';
import { appFieldsFileSchema, appScreensFileSchema } from '@taki/data-model';

/** Contrat pur du document d'instance, commun au SDK et au relais IA. */
export const INSTANCE_SCHEMA_VERSION = 1;

export const ficheInstancieeSchema = z.object({
  name: z.string().trim().min(1).max(80).optional(),
  description: z.string().trim().min(1).max(500).optional(),
  icon: z.string().trim().min(1).max(80).optional(),
  menu: z.object({ label: z.string().trim().min(1).max(40).optional() }).strict().optional(),
}).strict();

export const declarationSchema = z.object({
  champs: appFieldsFileSchema,
  ecrans: appScreensFileSchema,
  fiche: ficheInstancieeSchema.optional(),
}).strict();

export const modeleSchema = declarationSchema.extend({ version: z.string().trim().min(1) });

export const instancePayloadSchema = z.object({ modele: modeleSchema }).merge(declarationSchema).strict();

/** Racine non stricte en lecture : une clef future n'empêche pas l'app de monter. */
export const instanceDocumentSchema = z.object({
  orgId: z.string().min(1),
  appId: z.string().min(1),
  schemaVersion: z.literal(INSTANCE_SCHEMA_VERSION),
  champs: appFieldsFileSchema,
  ecrans: appScreensFileSchema,
  fiche: ficheInstancieeSchema.optional(),
  modele: modeleSchema,
});
